import { render, staticRenderFns } from "./securityReseller.vue?vue&type=template&id=396ae566&scoped=true"
import script from "./securityReseller.vue?vue&type=script&lang=js"
export * from "./securityReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ae566",
  null
  
)

export default component.exports